// extracted by mini-css-extract-plugin
export default {"srOnly":"yn0tiCnI4L6mrCoJh8xp"};